import { useEffect } from 'react';
import { Link, Route, BrowserRouter as Router, Routes, useLocation } from 'react-router-dom';
import './App.css';
import BackToTop from './components/BackToTop';
import Footer from './components/Footer';
import Header from './components/Header';
import { ThemeProvider } from './contexts/ThemeContext';
import Admin from './pages/Admin';
import AuthCallback from './pages/AuthCallback';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import ChangeLog from './pages/ChangeLog';
import Home from './pages/Home';

function Layout() {
  const location = useLocation();
  // The dashboard has its own navigation.
  const bareRoute =
    location.pathname.startsWith('/admin') || location.pathname.startsWith('/auth');

  useEffect(() => {
    const title = location.pathname === '/blog' ? 'Journal' : location.pathname === '/changelog' ? 'Changelog' : location.pathname.startsWith('/admin') ? 'Dashboard' : 'Design & Development';
    document.title = `${title} — Adrian Obadiah`;
    const target = location.hash.slice(1) || location.state?.scrollTo;
    const timer = window.setTimeout(() => {
      if (target) document.getElementById(target)?.scrollIntoView();
      else window.scrollTo({ top: 0, behavior: 'instant' });
    }, 0);
    return () => window.clearTimeout(timer);
  }, [location]);

  return (
    <div className={`app ${bareRoute ? 'app-bare' : 'app-public'}`}>
      {!bareRoute && <Header />}
      <div className="page">
        <main className="main-content" id="main" tabIndex="-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/changelog" element={<ChangeLog />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="*" element={<div className="container not-found"><p className="eyebrow">404 / A little off track</p><h1>This page took a different path.</h1><Link className="btn btn-primary" to="/">Back to home</Link></div>} />
          </Routes>
        </main>
        {!bareRoute && <Footer />}
        <BackToTop />
      </div>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <Layout />
      </Router>
    </ThemeProvider>
  );
}

export default App;
